import { get } from '../index';

export const getRevisionProject = (company) => {
  return get(`/tracking/projects-revisions/${company}`);
};
